jQuery( function ( $ ) {
    // 都道府県の配列
    const prefArray = [
        'hokkaido', 'aomori', 'iwate', 'miyagi','akita', 'yamagata', 'fukushima',
        'ibaraki', 'tochigi', 'gunma', 'saitama', 'chiba', 'tokyo', 'kanagawa', 'yamanashi',
        'niigata', 'toyama', 'ishikawa', 'fukui', 'nagano',
        'gifu', 'shizuoka', 'aichi', 'mie',
        'shiga', 'kyoto', 'osaka', 'hyogo', 'nara', 'wakayama',
        'tottori', 'shimane', 'okayama', 'hiroshima', 'yamaguchi',
        'tokushima', 'kagawa', 'ehime', 'kochi',
        'fukuoka', 'saga', 'nagasaki', 'kumamoto', 'oita', 'miyazaki', 'kagoshima', 'okinawa'
    ];

    let status = 'area';

    /*
    ** エリアを選択したとき
    */
    $( '.js-prefSelect__areaButton' ).on( 'click', function() {
        const area = $( this ).closest( '.js-prefSelect__area' );
        const pref = $( this ).closest( '.js-prefSelect' ).find( '.js-prefSelect__pref' );
        const prefList = pref.children( '.js-prefSelect__prefList' );
        const areaName = $( this ).data( 'area' );

        // すでにアクティブの場合は、解除する
        if ( $( this ).hasClass( 'is-active' ) ) {
            $( this ).removeClass( 'is-active' );
            area.removeClass( 'is-disabled' );
            pref.removeClass( 'is-active' );
            if ( window.matchMedia( "(min-width: 600px)" ).matches && !$( this ).hasClass( 'c-select-button--aside' )) {
                pref.slideUp( function() {
                    prefList.removeClass( 'is-active' );
                });
            }
            status = 'area';
        } else {
            $( this ).siblings( '.js-prefSelect__areaButton' ).removeClass( 'is-active' );
            $( this ).addClass( 'is-active' );
            prefList.map( (i, e) => {
                if ( e.dataset.area === areaName ) {
                    e.classList.add( 'is-active' );
                } else {
                    e.classList.remove( 'is-active' );
                }
            } );
            area.addClass( 'is-disabled' );
            pref.addClass( 'is-active' );
            // PCの場合の処理
            if ( window.matchMedia( "(min-width: 600px)" ).matches && !$( this ).hasClass( 'c-select-button--aside' ) ) {
                const activePrefButton = $('.js-prefSelect__prefList.is-active').children('.js-prefSelect__prefButton');
                activePrefButton.each(function() {
                    const prefName = $(this).data('pref');
                    const methodButtons = `<ul class="p-pref-select__methodList">
                    <li class="c-select-button--method-pc"><a href=""><span>地域</span>から探す</a></li>
                    <li class="c-select-button--method-pc"><a href=""><span>駅</span>から探す</a></li>
                    <li class="c-select-button--method-pc"><a href=""><span>地図</span>から探す</a></li>
                </ul>
        ` 
                });
                pref.slideDown();
            }
            history.pushState(null, null, null);
            status = 'pref';
        }
    } );

    /*
    ** 都道府県を選択したとき
    */
    $( '.js-prefSelect__prefButton' ).on( 'click', function( e ) {
        if ( window.matchMedia( "(max-width: 599.999px)" ).matches || $( this ).hasClass( 'c-select-button--aside' ) ) {
            const pref = $( this ).closest( '.js-prefSelect__pref' );
            const methods = $( this ).closest( '.js-prefSelect' ).find( '.js-prefSelect__method' );
            const methodButton = methods.find( '.js-prefSelect__methodButton' );
            pref.removeClass('is-active').addClass( 'is-disabled' );
            methods.addClass( 'is-active' );

            // 選択した都道府県名を表示する
            const prefNameJp = $( this ).children('span').text();
            const selectedPref = $( '.js-prefSelect__selectedPref' );
            selectedPref.text(prefNameJp);

            // 選択した都道府県をURLに入れる
            const prefName = $( this ).data( 'pref' );
            methodButton.each(function() {
                let href = $(this).children('a').attr('href');
                href = href.replace('prefName', prefName);
                $(this).children('a').attr('href', href);
            });

            status = 'method';
        }
    });

    //リサイズ時にすべて解除
    $( window ).on( 'resize', function() {
        let flag = '';
        if ( window.matchMedia( "(min-width: 600px)" ).matches && flag != 'pc') {
            flag = 'pc';
            status = 'area';
            $( '.js-prefSelect__areaButton' ).removeClass( 'is-active' );
            $( '.js-prefSelect__method' ).removeClass( 'is-active' );
            $( '.js-prefSelect__pref' ).removeAttr( 'style' ).removeClass( 'is-active' ).removeClass( 'is-disabled' );
            $( '.js-prefSelect__area' ).removeClass( 'is-disabled' );
            $( '.js-prefSelect__prefList' ).removeClass( 'is-active' );
            replacePrefName();
        } else if ( window.matchMedia( "(max-width: 599px)" ).matches && flag != 'sp') {
            flag = 'sp';
            status = 'area';
            $( '.js-prefSelect__areaButton' ).removeClass( 'is-active' );
            $( '.js-prefSelect__method' ).removeClass( 'is-active' );
            $( '.js-prefSelect__pref' ).removeAttr( 'style' ).removeClass( 'is-active' ).removeClass( 'is-disabled' );
            $( '.js-prefSelect__area' ).removeClass( 'is-disabled' );
            $( '.js-prefSelect__prefList' ).removeClass( 'is-active' );
            replacePrefName();
        }
    } );

    //戻るボタン
    $( '.js-prefSelect__backToArea' ).on( 'click', function() {
        status = 'area';
        const area = $( this ).closest( '.js-prefSelect' ).find( '.js-prefSelect__area' );
        const pref = $( this ).closest( '.js-prefSelect__pref' );
        const prefList = pref.children( '.js-prefSelect__prefList' );
        area.find( '.js-prefSelect__areaButton' ).removeClass( 'is-active' );
        area.removeClass( 'is-disabled' );
        pref.removeAttr( 'style' ).removeClass( 'is-active' );
        prefList.removeClass( 'is-active' );
    } );

    $( '.js-prefSelect__backToPref' ).on( 'click', function() {
        status = 'pref';
        const method = $( this ).closest( '.js-prefSelect__method' );
        const pref = $( this ).closest( '.js-prefSelect' ).find( '.js-prefSelect__pref' );
        pref.addClass('is-active').removeClass( 'is-disabled' );
        method.removeClass( 'is-active' );
        replacePrefName();
    } );

    // ブラウザバックで前に戻る
    $(window).on("popstate", function (event) {
        if( status === 'pref' ) {
            $( '.js-prefSelect__backToArea' ).click();
        } else if ( status === 'method' ) {
            $( '.js-prefSelect__backToPref' ).click();
        }
    });

    // 都道府県名をprefNameに戻す関数
    const replacePrefName = () => {
        const methodButtons = $( '.js-prefSelect__methodButton' );
        methodButtons.each(function() {
            let href = $(this).children('a').attr('href');
            for ( let i = 0; i < prefArray.length; i++) { 
                href = href.replace(prefArray[i], 'prefName', "g");
            }
            $(this).children('a').attr('href', href);
        });
    }
} );